import React from 'react';

import moment from 'moment';

import numero from 'numero-por-extenso';

import logoNotredame from '../../../../assets/logo_gndi.png';

import * as S from './styles';

function CartaDeCredito({ form }) {
    const DATE_FORMAT = 'DD/MM/YYYY';
    const DATE_FORMAT_API = 'MM/DD/YYYY hh:mm:ss';

    const { enderecoCobranca } = form.dataContrato || {};

    const { logradouro, numero: numeroEndereco, bairro, municipio, cep, siglaUf } = enderecoCobranca;

    const endereco = `${logradouro}, ${numeroEndereco} - ${bairro?.nome} ${cep} - ${municipio?.nome} - ${siglaUf}`;

    function formatMoney(value) {
        return parseFloat(value).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    }

    const valorCartaCredito = form.dataCartaCredito.valor.replace('.', '').replace(',', '.');

    function getMoneyText(value) {
        return numero.porExtenso(parseFloat(value), numero.estilo.monetario).toUpperCase();
    }

    return (
        <>
            <S.Container>
                <S.Header>
                    <S.LogoGroup>
                        <S.Logo src={logoNotredame} />
                    </S.LogoGroup>

                    <h3>Carta de Crédito</h3>
                </S.Header>

                <S.ContentContainer>
                    <S.Row>
                        SEFAT - <S.Value>{form.dataCartaCredito.numCartaCredito}</S.Value>
                    </S.Row>

                    <S.Row>A</S.Row>

                    <S.Row>{form.dataContrato.nome}</S.Row>

                    <S.Row>
                        CÓD - <S.Value>{form.dataCartaCredito.numDocReferencia}</S.Value>
                    </S.Row>

                    <S.Row>
                        <S.Value style={{ margin: 0 }}>{endereco}</S.Value>
                    </S.Row>

                    <br />
                    <S.Row style={{ fontWeight: 'bold' }}>Carta de Crédito - Interna</S.Row>
                    <br />

                    <S.Row>
                        REF: Fatura no. <S.Value>{form.dataCartaCredito.numFatura}</S.Value> de{' '}
                        <S.Value>{moment(form.dataFatura.dtEmissao, DATE_FORMAT_API).format(DATE_FORMAT)}</S.Value> -
                        Vencimento:{' '}
                        <S.Value>{moment(form.dataFatura.dtVencimento, DATE_FORMAT_API).format(DATE_FORMAT)}</S.Value>
                    </S.Row>

                    <S.ValuesContainer>
                        <S.Row className="spaced">
                            Valor da Fatura <S.Value>{formatMoney(form.dataFatura.valor)}</S.Value>
                        </S.Row>

                        <S.Row className="spaced">
                            Valor do Credito <S.Value>R$ {(form.dataCartaCredito.valor)}</S.Value>
                        </S.Row>
                    </S.ValuesContainer>

                    <br />
                    <br />
                    <S.Row>Prezados Senhores,</S.Row>
                    <br />
                    <S.Row className="spaced">
                        Conforme entendimentos mantidos com V. Sas, cancelaremos a importância de{' '}
                        <S.Value>R$ {(form.dataCartaCredito.valor)}</S.Value>
                    </S.Row>

                    <S.Row>
                        <S.Value style={{ margin: 0 }}>{getMoneyText(valorCartaCredito)}</S.Value>
                    </S.Row>

                    <S.Row>
                        referente a fatura no. <S.Value>{form.dataCartaCredito.numFatura}</S.Value> de{' '}
                        <S.Value>{moment(form.dataFatura.dtEmissao, DATE_FORMAT_API).format(DATE_FORMAT)}</S.Value> por
                        ocasião de seu pagamento.
                    </S.Row>

                    <br />
                    <br />
                    <S.Row>Sem outro particular, firmamo-nos</S.Row>

                    <br />
                    <br />
                    <S.Row>Atenciosamente,</S.Row>
                    <br />
                    <br />
                    <br />
                </S.ContentContainer>

                <S.ValuesContainer>
                    <S.Row>INTERMEDICA Saúde Ltda</S.Row>
                    <S.Row>CNPJ: 44.649.812/0001-38</S.Row>
                </S.ValuesContainer>
            </S.Container>
        </>
    );
}

export default CartaDeCredito;
